import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=ac64609c"
import script from "./Download.vue?vue&type=script&lang=ts"
export * from "./Download.vue?vue&type=script&lang=ts"
import style0 from "./Download.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports